import ZoneIcon from './component'

export default ZoneIcon
